import { ComponentIds } from '@inter-ikea-core/core';
import UprightComponent from '@inter-ikea-storagetwo/boaxel/dist/components/UprightComponent';
import { ProductType, PlannerEcsSystem } from '@inter-ikea-storageone/range';
/* Changes to uprights can affect the mounting rail products needed, so we remove the old
   invisible EXT mountings rail that correspond to mounting rails in the shopping cart, run
   the mounting rail optimization function and add new EXT mounting rails. */
export class OptimizeMountingRailsSystem extends PlannerEcsSystem {
    constructor(boaxelCoreApi) {
        super(boaxelCoreApi, 'OptimizeMountingRailsSystem', ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.products = [];
        this.boaxelCoreApi = boaxelCoreApi;
    }
    setMarketProducts(marketProducts) {
        this.products = marketProducts;
    }
    getCorrespondingExtMountingRailId(regularRailId) {
        const extRailId = this.products.find(product => product.type === ProductType.BOAXEL_MOUNTING_RAIL_EXT &&
            product.meta?.relatedArticle === regularRailId)?.coreProductId;
        if (!extRailId)
            return null;
        return extRailId;
    }
    removeCurrentExtMountingRailsInScene() {
        const optimizedRailsInScene = this.coreApi.entities.getByProductType(ProductType.BOAXEL_MOUNTING_RAIL_EXT);
        optimizedRailsInScene.forEach(rail => this.coreApi.getServices().entityManager.disposeEntity(rail));
    }
    findExtMountingRailAndAddEntityToScene(regularRailId) {
        const extRailId = this.getCorrespondingExtMountingRailId(regularRailId);
        if (!extRailId)
            throw new Error('Could not find ext mounting rail.');
        const entity = this.coreApi.getServices().productManager.createEntity(extRailId);
        if (!entity)
            throw new Error('Could not create entity for ext mounting rail.');
        this.coreApi.entities.placementService.forcePlaceEntity(entity);
    }
    updateExtMountingRailsOnScene() {
        if (!this.products.length)
            return; // Don't try to update before products have been loaded.
        this.removeCurrentExtMountingRailsInScene();
        const optimizedRailIds = this.boaxelCoreApi.calculateOptimalMountingRailSetupForAllSolutions();
        if (!optimizedRailIds)
            return;
        optimizedRailIds.flat().forEach(railId => this.findExtMountingRailAndAddEntityToScene(railId));
    }
    onAdd(entity) {
        if (entity.hasComponent(UprightComponent.id)) {
            this.updateExtMountingRailsOnScene();
        }
    }
    onUpdate(entity) {
        if (entity.hasComponent(UprightComponent.id)) {
            this.updateExtMountingRailsOnScene();
        }
    }
    onRemove(entity) {
        if (entity.hasComponent(UprightComponent.id)) {
            this.updateExtMountingRailsOnScene();
        }
    }
}
//# sourceMappingURL=OptimizeMountingRailsSystem.js.map